const _ = require('lodash');

const ValidateDirective = {
    goToPath(binding, path) {
        const validate = binding.instance.v$;
        if(validate) {
            let objectValidate = validate;
            const pathArray = path.split('.');
            for(let i = 0; i < pathArray.length; i++) {
                objectValidate = objectValidate[pathArray[i]];
                if(objectValidate == null) {
                    return null;
                }
            }
            return objectValidate;
        }
        return null;
    },

    checkValidation(el, binding) {
        const instance = binding.instance;
        const value = binding.value;
        let path = binding.value;
        let pathsToValidate = [];
        if(value && value.path) {
            path = value.path;
        }
        if(_.isString(path)) {
            pathsToValidate.push(path);
        } else if(_.isArray(path)) {
            pathsToValidate = path;
        } else {
            console.log("Invalid validation path format");
            return;
        }
        let invalid = null;
        pathsToValidate.forEach((path) => {
            const objectValidate = ValidateDirective.goToPath(binding, path);
            if(objectValidate != null) {
                let isToValidate = true;
                if(value.vuelidateCondition) {
                    isToValidate = value.vuelidateCondition(objectValidate, path);
                }
                if(instance.vuelidateCondition) {
                    isToValidate = isToValidate && instance.vuelidateCondition(objectValidate, path);
                }
                if(isToValidate) {
                    objectValidate.$touch();
                    if(objectValidate.$dirty) {
                        if(instance.onCheckValidation) {
                            instance.onCheckValidation(objectValidate, path);
                        }
                        invalid = (objectValidate.$errors && objectValidate.$errors.length > 0);
                    }
                }
            }
        });
        if(invalid !== null) {
            if(invalid === false) {
                el.classList.remove('v-invalid');
                if(instance["onFieldValid"]) {
                    instance.onFieldValid(objectValidate, path);
                }
            } else {
                el.classList.add('v-invalid');
            }
        }
    },
    beforeMount(el, binding, vnode) {
      el.classList.add('validate');
      el.checkValidationInput = () => ValidateDirective.checkValidation(el, binding, vnode);
      el.addEventListener('input',
        el.checkValidationInput
      );

      el.checkValidationAllInputs = () => {
        ValidateDirective.checkValidation(el, binding, vnode);
      };
      if(binding && binding.instance && binding.instance.emitter) {
        binding.instance.emitter.on("validate-all", el.checkValidationAllInputs);
      }
    },
    beforeUnmount(el, binding, vnode, prevVnode) {
      el.removeEventListener('input', el.checkValidationInput);
      if(binding && binding.instance && binding.instance.emitter) {
        binding.instance.emitter.off("validate-all", el.checkValidationAllInputs);
      }
    },
};
export default ValidateDirective;
